import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const getStopGeneratingModalProps = (t, editorHost) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  return {
    content: usesClassicModalChrome ? t('accessibility-wizard.alt-text.stop-generating-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.alt-text.stop-generating-modal.content')),
    primaryButtonText: t('accessibility-wizard.alt-text.stop-generating-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.alt-text.stop-generating-modal.secondary-button'),
    skin: 'standard',
    title: t('accessibility-wizard.alt-text.stop-generating-modal.title')
  };
};
export const showStopGeneratingSuggestionsModal = async _ref => {
  let {
    biLogger,
    handleApply,
    a11yWizardAdapter,
    t,
    handleDiscard,
    editorHost
  } = _ref;
  const modalProps = {
    ...getStopGeneratingModalProps(t, editorHost),
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.ContinueGenerating,
        modalType: BiModalTypes.GenerateWithAi
      });
      handleApply();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.StopGenerating,
        modalType: BiModalTypes.GenerateWithAi
      });
      handleDiscard();
    }
  };
  biLogger.modalView({
    modalType: BiModalTypes.GenerateWithAi
  });
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  if (usesClassicModalChrome) {
    await a11yWizardAdapter.showDialog({
      ...modalProps,
      theme: modalProps.skin
    });
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-stop-generating-suggestions-modal.js.map